import { fieldConfig } from "@autoform/zod";
import { z } from "zod";

import { TicketingAwareObjectWrapper } from "@/components/ui/autoform/components/custom/TicketingAwareObjectWrapper";
import { DynamicFormSchema } from "@/pages/events/schemas/order-form";

export const providerMetadataSchema = z.object({
  id: z.string(),
  provider: z.string(),
  // `ProviderMetadataDbDto.Url` — was missing, so every save dropped it.
  url: z.string().nullish(),
  logo: z.string(),
  headers: z.any(),
  createdAt: z.coerce
    .date()
    .transform((d) => d.toISOString())
    .pipe(z.string().datetime({ offset: true })),
  updatedAt: z.coerce
    .date()
    .transform((d) => d.toISOString())
    .pipe(z.string().datetime({ offset: true }))
    .nullish(),
});

export const eventTicketingSchema = z
  .object({
    available: z
      .boolean()
      .nullish()
      .superRefine(fieldConfig({ inputProps: { required: false } })),
    url: z.string(),
    provider: z.string().superRefine(fieldConfig({ fieldType: "hidden" })),
    providerMetadata: providerMetadataSchema
      .nullish()
      .superRefine(fieldConfig({ fieldType: "providerSelect" })),
    form: DynamicFormSchema.nullish(),
    groups: z.array(z.any()).nullish(),
    serviceFee: z
      .object({ flat: z.coerce.number(), percentage: z.coerce.number() })
      .nullish(),
    organiserIds: z
      .array(z.string())
      .nullish()
      .superRefine(fieldConfig({ fieldType: "tagList" })),
    createdAt: z
      .string()
      .datetime({ offset: true })
      .nullish()
      .superRefine(
        fieldConfig({
          fieldType: "datetime",
          inputProps: { disabled: true },
        }),
      ),
    updatedAt: z
      .string()
      .datetime({ offset: true })
      .nullish()
      .superRefine(
        fieldConfig({
          fieldType: "datetime",
          inputProps: { disabled: true },
        }),
      ),
  })
  // Passthrough: the event update writes `ticketing` whole, and
  // `TicketingDbDto` carries keys this form does not model (`status`,
  // `actionCache`, `maxCapacity`, `reservationTime`). Stripping them here
  // deleted them on every save of a partner-ticketed event.
  .passthrough();
